import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { useApp } from '@/hooks/useApp'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Box, Stack, Text } from '@chakra-ui/react'
import { Product } from 'BrokerTsLib/src/enums'
import CPPContent from './CPPContent'

const CPP = () => {
  const { product } = useApp()

  let productInfo: string | null = null
  switch (product) {
    case Product.VehicleInsurance: productInfo = 'Pojištění vozidel Česká podnikatelská pojišťovna'; break
  }

  return (
    <PageWrapper
      header={<DashboardHeader title={(
        <>
          <Stack color='white' alignItems='center'>
            <Box>Produktové informace</Box>
            {productInfo && <Box fontSize='5xl'>{productInfo}</Box>}
          </Stack>
        </>
      )}
      />}
      mainProps={{ sx: { pt: 8, gap: 4, display: 'grid' } }}
    >
      <CPPContent />
    </PageWrapper >
  )
}

export default CPP